import {
    AppURLSearchParams, LoginCredentialParams
} from '../../../../auth';

export function isLoginCredentials (params: any): params is LoginCredentialParams {
    return (
        typeof params?.[AppURLSearchParams.username] === 'string' &&
        typeof params?.[AppURLSearchParams.password] === 'string'
    );
}
